import { DataType } from '@/util/index'

/* const Menu = [
  /!* WELCOME *!/
  { header: 'Apps' },
  {
    text: 'Welcome',
    title: 'Welcome',
    icon: 'pets',
    name: 'Welcome',
    to: '/welcome',
    code: DataType.PrivilegeCode.WELCOME
  },
  { divider: true },
  /!* PRE-ORIGINATION *!/
  { header: 'Pre-Origination' },
  {
    text: 'Workbench',
    title: 'Workbench',
    icon: 'airplay',
    name: 'Workbench',
    to: '/pre-origination/workbench',
    code: DataType.PrivilegeCode.WORKBENCH
  },
  {
    text: 'Application Queue',
    title: 'Application Queue',
    icon: 'layers',
    name: 'Application Queue',
    to: '/pre-origination/application/queue',
    code: DataType.PrivilegeCode.LOAN_QUEUE
  },
  { divider: true },
  /!* POST-ORIGINATION *!/
  { header: 'Post-Origination' },
  {
    text: 'Application Queue',
    title: 'Application Queue',
    icon: 'layers',
    name: 'Application Queue',
    to: '/post-origination/application/queue',
    code: DataType.PrivilegeCode.LOAN_QUEUE_POST
  },
  { divider: true },
  /!* COLLECTION *!/
  { header: 'Collection' },
  {
    text: 'Application Queue',
    title: 'Application Queue',
    icon: 'layers',
    name: 'Application Queue',
    to: '/collection/application/queue',
    code: DataType.PrivilegeCode.LOAN_QUEUE_LCS
  },
  {
    text: '3rd Party',
    title: '3rd Party',
    icon: 'device_hub',
    name: '3rd Party',
    group: '3rd Party',
    code: DataType.PrivilegeCode.LOAN_QUEUE_LCS,
    children: [
      {
        text: 'Queue',
        title: 'Queue',
        icon: 'layers',
        name: 'Queue',
        to: '/collection/third-party/queue'
      },
      {
        text: 'Upload',
        title: 'Upload',
        icon: 'backup',
        name: 'Upload',
        to: '/collection/third-party/upload'
      },
      {
        text: 'Send Email',
        title: 'Send Email',
        icon: 'forward_to_inbox',
        name: 'Send Email',
        to: '/collection/third-party/send-email'
      },
      {
        text: 'WA Download',
        title: 'WA Download',
        icon: 'cloud_download',
        name: 'WA Download',
        to: '/collection/third-party/wa-download'
      }
    ]
  },
  { divider: true },
  { header: 'Reporting' },
  {
    text: 'Originated Report',
    title: 'Originated Report',
    icon: 'analytics',
    name: 'Originated Report',
    to: '/reporting/originated-report',
    code: DataType.PrivilegeCode.ORIGINATED_REPORT
  },
  {
    text: 'Purchased Report',
    title: 'Purchased Report',
    icon: 'analytics',
    name: 'Purchased Report',
    to: '/reporting/purchased-report',
    code: DataType.PrivilegeCode.PURCHASED_REPORT
  },
  {
    text: 'Tribe Summary Report',
    title: 'Tribe Summary Report',
    icon: 'analytics',
    name: 'Tribe Summary Report',
    to: '/reporting/tribe-summary-report',
    code: DataType.PrivilegeCode.TRIBE_SUMMARY_REPORT
  },
  {
    text: 'Withdrawn Report',
    title: 'Withdrawn Report',
    icon: 'analytics',
    name: 'Withdrawn Report',
    to: '/reporting/withdrawn-report',
    code: DataType.PrivilegeCode.WITHDRAWN_REPORT
  },
  {
    text: 'Correction Reason Report',
    title: 'Correction Reason Report',
    icon: 'analytics',
    name: 'Correction Reason Report',
    to: '/reporting/correction-reason-report',
    code: DataType.PrivilegeCode.CORRECTION_REASON_REPORT
  },
  {
    text: 'Export History',
    title: 'Export History',
    icon: 'history',
    name: 'Export History',
    to: '/reporting/export-history',
    code: DataType.PrivilegeCode.EXPORT_HISTORY
  }
] */

const Menu = [
  { header: 'Apps' },
  /* WELCOME */
  {
    text: 'Welcome',
    title: 'Welcome',
    icon: 'pets',
    name: 'Welcome',
    to: '/welcome',
    code: DataType.PrivilegeCode.WELCOME
  },
  /* PRE-ORIGINATION */
  {
    text: 'Pre-Origination',
    title: 'Pre-Origination',
    icon: 'badge',
    name: 'Pre-Origination',
    // group: 'los',
    children: [
      {
        text: 'Workbench',
        title: 'Workbench',
        icon: 'airplay',
        name: 'Workbench',
        to: '/pre-origination/workbench',
        code: DataType.PrivilegeCode.WORKBENCH
      },
      {
        text: 'Work Queue',
        title: 'Work Queue',
        icon: 'layers',
        name: 'Work Queue',
        to: '/pre-origination/application/queue',
        code: DataType.PrivilegeCode.LOAN_QUEUE
      },
      {
        text: 'Manually Create Lead',
        title: 'Manually Create Lead',
        icon: 'layers',
        name: 'Manually Create Lead',
        to: '/pre-origination/manually-create-lead',
        code: DataType.PrivilegeCode.MANUALLY_CREATE_LEAD
      }
    ]
  },
  /* POST-ORIGINATION */
  {
    text: 'Post-Origination',
    title: 'Post-Origination',
    icon: 'credit_score',
    name: 'Post-Origination',
    // group: 'pps',
    children: [
      {
        text: 'Work Queue',
        title: 'Work Queue',
        // icon: 'layers',
        name: 'Work Queue',
        to: '/post-origination/application/queue',
        code: DataType.PrivilegeCode.LOAN_QUEUE_POST
      },
      {
        text: 'Special Queue',
        title: 'Special Queue',
        name: 'Special Queue',
        to: '/post-origination/special/queue',
        code: DataType.PrivilegeCode.SPECIAL_QUEUE
      },
      {
        text: 'Complaint Queue',
        title: 'Complaint Queue',
        name: 'Complaint Queue',
        to: '/post-origination/complaint/queue',
        code: DataType.PrivilegeCode.COMPLAINT_QUEUE
      },
      {
        text: 'To Be Confirmed Queue',
        title: 'To Be Confirmed Queue',
        name: 'To Be Confirmed Queue',
        to: '/post-origination/toBeConfirmed/queue',
        code: DataType.PrivilegeCode.TO_BE_CONFIRMED_QUEUE
      }
    ]
  },
  /* IN-HOUSE COLLECTION */
  {
    text: 'In-House Collection',
    title: 'In-House Collection',
    name: 'In-House Collection',
    icon: 'map',
    children: [
      {
        text: 'Work Queue',
        title: 'Work Queue',
        name: 'Work Queue',
        to: '/collection/in-house/in-house-queue',
        code: DataType.PrivilegeCode.IN_HOUSE_QUEUE_MENU
      },
      {
        text: 'CCCS Queue',
        title: 'CCCS Queue',
        name: 'CCCS Queue',
        to: '/collection/in-house/cccs-queue',
        code: DataType.PrivilegeCode.CCCS_QUEUE_MENU
      },
      {
        text: 'Special Queue',
        title: 'Special Queue',
        name: 'Special Queue',
        to: '/collection/in-house/in-house-special-queue',
        code: DataType.PrivilegeCode.IN_HOUSE_OVERFLOW_QUEUE_MENU
      },
      {
        text: 'Overflow Queue',
        title: 'Overflow Queue',
        name: 'Overflow Queue',
        to: '/collection/in-house/in-house-overflow-queue',
        code: DataType.PrivilegeCode.IN_HOUSE_OVERFLOW_QUEUE_MENU
      },
      {
        text: 'Bankruptcy Queue',
        title: 'Bankruptcy Queue',
        name: 'Bankruptcy Queue',
        to: '/collection/in-house/bankruptcy-queue',
        code: DataType.PrivilegeCode.BANKRUPTCY_QUEUE_MENU
      },
      {
        text: 'Miscellaneous Queue',
        title: 'Miscellaneous Queue',
        name: 'Miscellaneous Queue',
        to: '/collection/in-house/miscellaneous-queue',
        code: DataType.PrivilegeCode.MISCELLANEOUS_QUEUE_MENU
      }
    ]
  },
  /* EXTERNAL COLLECTION */
  {
    text: 'External Collection',
    title: 'External Collection',
    name: 'External Collection',
    icon: 'group_work',
    children: [
      {
        text: 'Work Queue',
        title: 'Work Queue',
        name: 'Work Queue',
        to: '/collection/third-party/queue',
        code: DataType.PrivilegeCode.WA_QUEUE
      },
      {
        text: 'Overflow Queue',
        title: 'Overflow Queue',
        name: 'Overflow Queue',
        to: '/collection/third-party/external-overflow-queue',
        code: DataType.PrivilegeCode.EXTERNAL_OVERFLOW_QUEUE_MENU
      },
      {
        text: 'Upload',
        title: 'Upload',
        name: 'Upload',
        to: '/collection/third-party/upload',
        code: DataType.PrivilegeCode.WA_UPLOAD
      },
      {
        text: 'Notification',
        title: 'Notification',
        name: 'Notification',
        children: [
          {
            text: 'Send Email To Customer',
            title: 'Send Email To Customer',
            name: 'Send Email To Customer',
            to: '/collection/third-party/send-email-to-customer',
            code: DataType.PrivilegeCode.SEND_EMAIL_TO_CUSTOMER
          },
          {
            text: 'Send Email To Employer',
            title: 'Send Email To Employer',
            name: 'Send Email To Employer',
            to: '/collection/third-party/send-email-to-employer',
            code: DataType.PrivilegeCode.SEND_EMAIL_TO_EMPLOYER
          },
          {
            text: 'Send Fax To Employer',
            title: 'Send Fax To Employer',
            name: 'Send Fax To Employer',
            to: '/collection/third-party/send-fax-to-employer',
            code: DataType.PrivilegeCode.SEND_FAX_TO_EMPLOYER
          }
        ]
      },
      {
        text: 'Download File',
        title: 'Download File',
        name: 'Download File',
        to: '/collection/third-party/download-file',
        code: DataType.PrivilegeCode.WA_DOWNLOAD
      },
      {
        text: 'Collection Management',
        title: 'Collection Management',
        name: 'Collection Management',
        to: '/collection/third-party/collection-management',
        code: DataType.PrivilegeCode.COLLECTION_MANAGEMENT
      },
      {
        text: 'Third Party',
        title: 'Third Party',
        name: 'Third Party',
        to: '/collection/third-party/third-party',
        code: DataType.PrivilegeCode.THIRD_PARTY_MENU
      }
    ]
  },
  /* SETTING */
  {
    text: 'Setting',
    title: 'Setting',
    icon: 'settings',
    name: 'Setting',
    children: [
      {
        text: 'Complaint Filter Management',
        title: 'Complaint Filter Management',
        name: 'Complaint Filter Management',
        to: '/setting/complaint-filter-management',
        code: DataType.PrivilegeCode.COMPLAINT_FILTER_MANAGEMENT_MENU
      },
      {
        text: 'SSN Filter Management',
        title: 'SSN Filter Management',
        name: 'SSN Filter Management',
        to: '/setting/ssn-filter-management',
        code: DataType.PrivilegeCode.SSN_FILTER_MANAGEMENT_MENU
      },
      {
        text: 'High Risk Filter',
        title: 'High Risk Filter',
        name: 'High Risk Filter',
        to: '/filter-management/high-risk-filter',
        code: DataType.PrivilegeCode.HIGH_RISK_FILTER
      }
    ]
  }
]

export default Menu
